import './src/styles/main.css'

export const onRouteUpdate = ({ location, prevLocation }) => {
	document.body.className = ''
	if (
		location.pathname === '/' ||
		location.pathname === '/app' ||
		location.pathname === '/app/'
	) {
		document.body.classList.add('home')
	} else {
		document.body.classList.add('common')
	}
}
